import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const AssetUpdateDraftBodySchema = z
    .object({
        partyPayload: z
            .object({
                templateCode: z.string().optional(),
                assignmentsByRole: z.record(z.array(z.any())).optional(),
            })
            .optional()
            .nullable(),
    })
    .passthrough();

export const EntityUpdateDraftSummaryQuerySchema = z.object({
    ids: z.string().min(1),
    pageKey: z.string().optional(),
});

export const EntityUpdateDraftResponseSchema = z.object({
    pendingChangeId: optionalMongoObjectId,
    approvalStatus: z.enum(['draft', 'submitted']).optional(),
    merged: z.boolean().optional(),
    locked: z.boolean().optional(),
});
